export const GENDER_OPTIONS = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Transgender', label: 'Transgender' },
  {
    value: 'Non-binary / Non-conforming',
    label: 'Non-binary / Non-conforming',
  },
  { value: 'Prefer Not to Respond', label: 'Prefer Not to Respond' },
  { value: 'Other', label: 'Other' },
] as const;
